// extracted by mini-css-extract-plugin
module.exports = {"camPlayer":"CamPlayer_camPlayer__gjUsZ"};